import { motion } from 'framer-motion';
import styled from 'styled-components';

import LinkComp from 'components/LinkComp/LinkComp';
import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

import InsightsTileComponent from './sections/InsightsTile/InsightsTile';

const { threeFourth, max } = layout.columns;

export const Wrapper = styled(motion.div)`
  padding: 223px 0 64px;

  position: relative;

  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(${max}, [content] minmax(0px, 1fr))
    [out-right] 16px;

  ${mediaDesktop(`
    grid-template-columns: [out-left] 124px repeat(${max}, [content] minmax(0px, 1fr)) [out-right] 124px;
  `)}

  ${mediaTablet(`
    padding: 153px 0 360px;
  `)}
`;

export const HeadlineWrapper = styled.section`
  margin-bottom: 214px;
  grid-column: 2/-2;

  ${mediaDesktop(`
    grid-column: content 1/content 9;
    margin-bottom: 160px;
  `)}
`;

export const InsightsList = styled.div`
  grid-column: 2/ -2;
  display: grid;

  position: relative;
  z-index: 0;

  grid-template-columns: 1fr;
  grid-gap: 48px 0;

  ${mediaDesktop(`
    grid-column: 2/ -2;

    grid-gap: 72px 32px;
    grid-template-columns: repeat(${threeFourth}, 1fr);
  `)}
`;

export const InsightsTile = styled(InsightsTileComponent)`
  display: flex;
  flex-direction: column;
`;

export const FilterContainer = styled.div`
  min-height: 52px;
  display: flex;
  justify-content: center;
  position: sticky;
  top: 90%;
  grid-column: 1/-1;
  z-index: ${layout.zIndex.filter};

  ${mediaDesktop(`
    position: fixed;
    left: 32px;
    top: auto;
    bottom: 25px;

    width: fit-content;
    min-height: 55px;
    grid-column: 1 / ${max};

    > div {
      bottom: 0;
    }
  `)}
`;

export const Link = styled(LinkComp)`
  a {
    user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -webkit-app-region: no-drag;
  }
`;
